<template>
  <div class="body-form">
    <Loading v-if="isLoading" />
    <Popup :message="message" v-if="isPopup" @close="() => (isPopup = false)" />
    <div style="width: 90%; margin: 30px 0;">
      <div class="menus-top">
        <span class="blue-text" @click="$router.go(-1)">FAQ</span>
        <Arrow :width="20" :height="20" direct="left" strokeColor="#7B7E8C" class="icon" />
        <span style="color: #7b7e8c">{{ name }}</span>
      </div>
      <div class="card-form-head">
        <h1>Form {{ name }}</h1>
      </div>
      <div class="tab-selector" v-if="isEdit || isWatch">
        <button
          :class="['tab', activeTab === 'id' ? 'active-tab' : '']"
          @click="activeTab = 'id'"
        >
          Bahasa Indonesia
        </button>
        <button
          :class="['tab', activeTab === 'en' ? 'active-tab' : '']"
          @click="activeTab = 'en'"
        >
          Bahasa Inggris
        </button>
      </div>
      <div v-if="activeTab === 'id'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Indonesia</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Kategori</p>
              <v-select
                :disabled="isWatch"
                class="form-input"
                :items="categories"
                item-text="name"
                item-value="value"
                v-model="form.category"
                placeholder="Pilih kategori"
                solo
              ></v-select>
            </div>
            
            <div class="content-form mb-4">
              <p>Menampilkan di page inti</p>
              <v-switch
              v-model="form.is_main"
              color="primary"
              :label="form.is_main ? 'Aktif': 'Tidak aktif'"
              hide-details
              v-if="!isWatch"
            ></v-switch>
            </div>
            <div class="content-form">
              <p>Pertanyaan</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.question"
                class="form-input"
                placeholder="Tulis Pertanyaan"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form mb-5">
              <p>Jawaban</p>
              <vue-editor
                v-model="form.answer"
                :editorToolbar="$helpers.customToolBar()"
                class="form-input"
                v-if="!isWatch"
              ></vue-editor>
              <div v-else class="watch-ctn">
                <div v-html="form.answer"></div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      <div v-if="activeTab === 'en'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Inggris</h1>
          </v-card-title>
          <div class="mt-5">
            
            <div class="content-form">
              <p>Question</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="formEng.question"
                class="form-input"
                placeholder="Write Question"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form mb-5">
              <p>Answer</p>
              <vue-editor
                v-model="formEng.answer"
                :editorToolbar="$helpers.customToolBar()"
                class="form-input"
                v-if="!isWatch"
              ></vue-editor>
              <div v-else class="watch-ctn">
                <div v-html="formEng.answer"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="submit-box" v-if="!isWatch">
        <Button name="PUBLISH" width="260px" @click="onSubmit" :disabled="!validData" />
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/ilustration/Loading.vue";
import { VueEditor } from "vue2-editor";
import Button from "../../../components/Button.vue";
import Popup from "@/components/others/Popup.vue";
import Arrow from '@/components/icons/Arrow.vue';

export default {
  components: {
    VueEditor,
    Button,
    Loading,
    Popup,
    Arrow,
  },
  name: "FormFAQ",
  data() {
    return {
      id: null,
      modal: false,
      name: "",
      isLoading: false,
      isWatch: false,
      isEdit: false,
      message: "",
      isPopup: false,
      activeTab: "id", // Default tab: Bahasa Indonesia
      categories: [
        { name: "Kampus Merdeka (Global)", value: "KAMPUS_MERDEKA" },
        { name: "Kampus Merdeka (Magang)", value: "MAGANG" },
        { name: "Prakerja", value: "PRAKERJA" },
        { name: "Home", value: "HOME" },
        { name: "Bootcamp", value: "BOOTCAMP" },
        { name: "Public Training", value: "PUBLIC_TRAINING" },
        { name: "Detail kelas", value: "DETAIL_CLASS" },
        { name: "Corporate", value: "CORPORATE" },
        { name: "Akselerasi", value: "ACCELERATION" },
        { name: "Corporate Training", value: "TRAINING" },
        { name: "Akselerasi Class", value: "ACCELERATION_CLASS" },
        { name: "Corporate Collaboration", value: "COLLABORATION" },
        { name: "Talent as a service", value: "TALENT_SERVICE" },
        { name: "Technology Service", value: "SERVICES" },
        { name: "Career", value: "CAREER" },
        { name: "Event", value: "EVENT" },
      ],
      form: {
        question: "",
        answer: "",
        category: "",
        is_main: false,
      },
      formEng: {
        question: "",
        answer: "",
      },
    };
  },
  computed: {
    validData() {
      return (
        this.form.question &&
        this.form.answer &&
        this.form.category
      );
    },
  },
  methods: {
    checkingType() {
      this.name = this.$route.meta.name;
      this.isWatch = this.$route.path.lastIndexOf("watch") >= 0;
      this.isEdit = this.$route.path.lastIndexOf("edit") >= 0;
      this.id = this.$route.params.id;
      if (!this.id) return;
      this.getDataFAQ();
    },
    async getDataFAQ() {
      this.isLoading = true;
      try {
        const resp = await this.$crm_http.get("/v1/faq/" + this.id);
        const data = resp.data.data;

        // Populate Bahasa Indonesia
        this.form.question = data.question || "";
        this.form.answer = data.answer || "";
        this.form.category = data.category || "";
        this.form.is_main = data.is_main || false;

        // Populate Bahasa Inggris (if available)
        if (this.isEdit) {
          this.getBilingual();
        }

        this.isLoading = false;
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to load data.";
        this.isPopup = true;
        this.isLoading = false;
      }
    },
    async getBilingual() {
      try {
        const { data } = await this.$crm_http.get(
          `/v1/bilingual/record/${this.id}?table_name=faq&language_code=en`
        );
        const resp = JSON.parse(data.data.bilingual?.translated_data || "{}");
        
        this.formEng.question = resp?.question || "";
        this.formEng.answer = resp?.answer || "";
      } catch (err) {
        console.log(err);
      }
    },
    async onSubmit() {
      this.isLoading = true;
      try {
        const payload = {
          question: this.form.question,
          answer: [this.form.answer],
          category: this.form.category,
          is_main: this.form.is_main,
        };

        if (this.isEdit) {
          await this.$crm_http.put("/v1/faq/" + this.id, payload);
          this.onSubmitBilingual();
        } else {
          await this.$crm_http.post("/v1/faq", payload);
        }

        setTimeout(() => {
          this.$router.push("/faq");
        }, 2000);
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to submit data.";
        this.isPopup = true;
        this.isLoading = false;
      }
    },
    async onSubmitBilingual() {
      const payload = {
        table_name: "faq",
        record_id: this.id,
        language_code: "en",
        translated_data: JSON.stringify({
          question: this.formEng.question,
          answer: this.formEng.answer,
          category: this.form.category,
          is_main: this.form.is_main,
        }),
      };

      try {
        await this.$crm_http.post("/v1/bilingual", payload);
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.checkingType();
  },
};
</script>

<style scoped>
.body-form {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fafaf9;
  padding-bottom: 30px;
  min-height: 100vh;
}
.menus-top {
  padding-top: 10px;
  display: flex;
  font-size: 16px;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}
.card-form-head {
  display: flex;
  margin: 40px 0;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}
.card-form-head-2 {
  display: flex;
  margin-left: -35px;
  margin-right: -20px;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid gray;
}
.card-form-head-2 h1 {
  font-weight: 700;
  font-size: 18px;
  color: #36373f;
  font-family: "Poppins", sans-serif;
  margin: 0;
}
.tab-selector {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 50px;
}
.tab {
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
  background-color: #f9f9f9;
}
.active-tab {
  background-color: #2d46cf;
  color: white;
  border-color: #2d46cf;
}
.cart-form {
  position: relative;
  margin: 40px 0;
  border-radius: 30px;
  padding: 30px 40px;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}
.language-section {
  margin-bottom: 30px;
}
.content-form {
  margin-top: 15px;
}
.content-form p {
  font-size: 14px;
  margin: 3px 0;
  font-weight: bold;
}
.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}
.form-input:focus {
  border-color: #2d46cf;
  box-shadow: 0 0 5px rgba(45, 70, 207, 0.3);
}
.submit-box {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
.submit-box button {
  margin: 0;
  font-size: 16px;
  max-width: 400px;
  border-radius: 18px !important;
  width: 100%;
  padding: 10px;
  background-color: #2d46cf;
  color: white;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.submit-box button:hover {
  background-color: #1c319e;
}
.submit-box button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.blue-text {
  font-weight: bold;
  color: #162ca2;
  cursor: pointer;
}
</style>